import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import AuthContext from "../../context/AuthContext";

function EditOrder(props) {
  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  console.log("Invoice ID:", props.invoice_id);
  const [cat, setcat] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const getorders = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/invoice/details/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
              invoice_id: props.invoice_id,
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setcat(response.data);
          console.log("Invoice details data:", response.data);
        }
      } catch (error) {
        console.error("Error fetching invoice details:", error);
      }
    };
    getorders();

    return () => {
      isMounted = false;
    };
  }, [user.username, props.invoice_id, authTokens.access]);

  return (
    <div className="testi">
      <div className="mod">
        <table className="table">
          <thead>
            <tr>
              <th>Item Type</th>
              <th>Item Name</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {cat.map((item, index) => (
              <tr key={index}>
                <td>{item.item_type}</td>
                <td>
                  {item.item_type.toLowerCase() === "product" &&
                  item.product_name
                    ? item.product_name
                    : item.item_type.toLowerCase() === "service" &&
                      item.service_name
                    ? item.service_name
                    : "N/A"}
                </td>
                <td>{item.quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default EditOrder;
